"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _requestReceived = _interopRequireDefault(require("../../../actions/knock/requestReceived"));
var _user = require("../../../utils/user");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function directorRequested(_ref, payload) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  if ((0, _user.hasRealTimeCollaborationAccess)(getState)) {
    dispatch((0, _requestReceived["default"])(payload));
  }
}
var _default = exports["default"] = directorRequested;